import React from 'react';
import { number, oneOfType, string } from 'prop-types';

const Shimmer = (props) => {
  const { height, width, className } = props;
  const cls = `gradient ${className}`;
  return (
    <div className={cls} style={{ height, width }}>
      <style>
        {`
          .gradient {
            background: linear-gradient(90deg, #a6a6a6, #f9f8f8, #a6a6a6);
            background-size: 200% 200%;

            -webkit-animation: Animation 5s ease infinite;
            -moz-animation: Animation 5s ease infinite;
            animation: Animation 5s ease infinite;
          }

          @-webkit-keyframes Animation {
            0% {
              background-position: 10% 0%;
            }
            50% {
              background-position: 91% 100%;
            }
            100% {
              background-position: 10% 0%;
            }
          }
          @-moz-keyframes Animation {
            0% {
              background-position: 10% 0%;
            }
            50% {
              background-position: 91% 100%;
            }
            100% {
              background-position: 10% 0%;
            }
          }
          @keyframes Animation {
            0% {
              background-position: 10% 0%;
            }
            50% {
              background-position: 91% 100%;
            }
            100% {
              background-position: 10% 0%;
            }
          }
        `}
      </style>
    </div>
  );
};

Shimmer.propTypes = {
  height: oneOfType([number, string]).isRequired,
  width: oneOfType([number, string]).isRequired,
  className: string.isRequired,
};

export default Shimmer;
